import { ISearchParameters } from "../../../contexts/dataContext";
import VehicleApi from "./VehicleApi";
import moment from "moment";

class V3VehicleApi implements VehicleApi {
  fetchCustom: (
    url: string,
    options?: any,
    addAuthHeader?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options?: any,
      addAuthHeader?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  searchWithParams = (params:ISearchParameters, loggedIn: boolean) => {
    return this.search(loggedIn, params.startDate ? moment(params.startDate).clone().format("DD.MM.YYYY") : '' , params.startTime, params.endDate ? moment(params.endDate).clone().format("DD.MM.YYYY") : 'NOPE', params.endTime, params.lat, params.lon, params.distance, params.km,
      params.vehicleType, params.minTrunkVolume, params.fuelType, params.crossBorderArea, params.transmission, params.features,
      params.sort, params.showStart, params.showAmount, params.carId, params.discount, params.utm_campaign, params.utm_source,
        params.utm_term, params.utm_medium, params.utm_content, params.gclid, params.cid, params.cookie, params.mobileDevice, params.userPlaceSearch,
        params.searchCity, params.vehicleSegment);
  }

  search = (loggedIn: boolean, startDate: string, startTime: string, endDate: string, endTime: string,
    lat: number=0,  lon: number=0,  distance: number=0, km: number = 50,
    vehicleType?:string, minTrunkVolume?:number, fuelType?:string, crossBorderArea?: string, transmission?:string, features?:string,
    sort?:string, showStart?: number,  showAmount?:number, carId?:number, discount?:string, utm_campaign?: string, utm_source?: string,
            utm_term?: string, utm_medium?: string, utm_content?: string, gclid?: string, cid?: string, cookie?: string | null, mobileDevice?: boolean,
            userSearchLocation?: string, searchCity?: string, vehicleSegment?: string,
  ) => {
    let params = `?distance=${distance}&km=${km}&lat=${lat}&lon=${lon}&startDate=${startDate}&startTime=${startTime}&endDate=${endDate}&endTime=${endTime}`;
    params += carId ? `&carId=${carId }` : '';
    params += discount ? `&discount=${discount }` : '';
    params += vehicleType ? `&carModel=${encodeURIComponent(vehicleType)}` : '';
    params += minTrunkVolume ? `&minTrunkVolume=${minTrunkVolume}` : '';
    params += fuelType ? `&fuelType=${fuelType}` : '';
    params += sort ? `&sort=${sort}` : '';
    params += Number.isSafeInteger(showStart) ? `&showStart=${showStart}` : '';
    params += showAmount ? `&showAmount=${showAmount }` : '';
    params += crossBorderArea ? `&export=${crossBorderArea }` : '';
    params += transmission ? `&transmission=${transmission }` : '';
    params += features ? `&features=${features }` : '';
    params += '&client=rrm';
    params += utm_campaign?.length ? `&utm_campaign=${utm_campaign}` : '';
    params += utm_source?.length ? `&utm_source=${utm_source}` : '';
    params += utm_term?.length ? `&utm_term=${utm_term}` : '';
    params += utm_medium?.length ? `&utm_medium=${utm_medium}` : '';
    params += utm_content?.length ? `&utm_content=${utm_content}` : '';
    params += gclid?.length ? `&gclid=${gclid}` : '';
    params += cid?.length ? `&cid=${cid}` : '';
    params += cookie?.length ? `&cookie=${cookie}` : '';
    params += mobileDevice !== undefined ? `&mobile=${mobileDevice}` : `&mobile=true`; // fallback: true works on desktop+mobile
    params += userSearchLocation !== undefined ? `&userSearchLocation=${userSearchLocation}` : ``;
    params += searchCity?.length ? `&searchCity=${encodeURIComponent(searchCity)}` : ``;
    // Car/van intent, stored on the customer_behavior search row so the reservation
    // database can join searched segment to bookings. Absent when the customer used the
    // generic search button — the backend stores that as NULL, not as 'car'.
    params += vehicleSegment?.length ? `&vehicleSegment=${vehicleSegment}` : ``;
    params += `&login=${loggedIn ? 1 : 0}`;

    const onSale=true;
    params += onSale ? `&onsales=${onSale}` : '';
    
    const fetchUrl = `/vehicles/filter-search-cache`;
    
    return this.fetchCustom(fetchUrl+params);
  }

  oneWaySearchWithParams = (params:ISearchParameters, loggedIn: boolean) => {

    return this.oneWaySearch( params.startDate ? moment(params.startDate).clone().format("DD.MM.YYYY") : '' ,
        params.startTime, params.endDate ? moment(params.endDate).clone().format("DD.MM.YYYY") : 'NOPE', params.endTime,
        params.km, params.carId, params.pickupCity, params.returnCity, loggedIn, params.utm_campaign, params.utm_source,
        params.utm_term, params.utm_medium, params.utm_content, params.gclid, params.cid, params.cookie,
        params.vehicleSegment
        );
  }

  oneWaySearch = (startDate: string, startTime: string, endDate: string, endTime: string,
                  km: number = 100, carId?:number, pickupCity?: string, returnCity?: string, loggedIn?: boolean,
                  utm_campaign?: string, utm_source?: string, utm_term?: string, utm_medium?: string,
                  utm_content?: string, gclid?: string, cid?: string, cookie?: string | null,
                  vehicleSegment?: string
  ) => {
    let params = `?km=${km}&startDate=${startDate}&startTime=${startTime}
    &endDate=${endDate}&endTime=${endTime}&pickupCity=${pickupCity}&returnCity=${returnCity}`;
    params += carId ? `&carId=${carId }` : '';
    params += utm_campaign?.length ? `&utm_campaign=${utm_campaign}` : '';
    params += utm_source?.length ? `&utm_source=${utm_source}` : '';
    params += utm_term?.length ? `&utm_term=${utm_term}` : '';
    params += utm_medium?.length ? `&utm_medium=${utm_medium}` : '';
    params += utm_content?.length ? `&utm_content=${utm_content}` : '';
    params += gclid?.length ? `&gclid=${gclid}` : '';
    params += cid?.length ? `&cid=${cid}` : '';
    params += cookie?.length ? `&cookie=${cookie}` : '';
    params += vehicleSegment?.length ? `&vehicleSegment=${vehicleSegment}` : '';

    const fetchUrl = `/oneway-search`;
    if (loggedIn) {
      return this.fetchCustom('/anonymous' + fetchUrl+params);
    }
    return this.fetchCustom(fetchUrl+params);
  }
  
  getCoupon = (coupon: string) => {
    const fetchUrl = `/vehicles/validateCoupon/${coupon}`;
    return this.fetchCustom(fetchUrl);
  }

  getOneWayCityRoutes(loggedIn: boolean): Promise<any> {
    const fetchUrl = `/oneway-routes`;

    if (loggedIn) {
      return this.fetchCustom('/anonymous' + fetchUrl);
    }
    return this.fetchCustom(fetchUrl);
  }
}

export default V3VehicleApi;
